import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = ["part"]
const _hoisted_2 = { class: "card-img-top position-relative pt-5" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = {
  key: 0,
  style: {"position":"absolute","bottom":"0","right":"0","z-index":"2"}
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "d-flex justify-content-center text-center" }
const _hoisted_8 = {
  key: 1,
  class: "d-flex flex-column"
}
const _hoisted_9 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 2,
  class: "text-muted small"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 1,
  class: "fw-bold text-muted"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = {
  key: 0,
  class: "card-footer"
}
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = {
  key: 1,
  class: "position-absolute p-2 top-0 start-0 ext-select-checkbox",
  style: {"z-index":"1","width":"auto"}
}
const _hoisted_20 = ["checked", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InjectStyles = _resolveComponent("InjectStyles")!
  const _component_Image = _resolveComponent("Image")!
  const _component_VRuntimeTemplate = _resolveComponent("VRuntimeTemplate")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Clickable = _resolveComponent("Clickable")!
  const _component_slide = _resolveComponent("slide")!
  const _component_navigation = _resolveComponent("navigation")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_carousel = _resolveComponent("carousel")!
  const _component_ItemCatalogsDetailsModal = _resolveComponent("ItemCatalogsDetailsModal")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "root",
    class: _normalizeClass(["pis-component position-relative", _ctx.componentName]),
    part: _ctx.componentName
  }, [
    (_ctx.isReady && _ctx.componentOptions?.visible && _ctx.currentSettings)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.isWebComponent)
            ? (_openBlock(), _createBlock(_component_InjectStyles, {
                key: 0,
                items: _ctx.store?.options.styles
              }, null, 8, ["items"]))
            : _createCommentVNode("", true),
          _createVNode(_component_carousel, _mergeProps({ ref: "carousel" }, _ctx.settings, {
            breakpoints: _ctx.breakpoints,
            i18n: _ctx.i18n
          }), {
            addons: _withCtx(() => [
              (_ctx.currentSettings.navigationVisible)
                ? (_openBlock(), _createBlock(_component_navigation, { key: 0 }, {
                    next: _withCtx(() => [
                      _createVNode(_component_Icon, { glyph: "carousel-right" })
                    ]),
                    prev: _withCtx(() => [
                      _createVNode(_component_Icon, { glyph: "carousel-left" })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.currentSettings.paginationVisible)
                ? (_openBlock(), _createBlock(_component_pagination, { key: 1 }))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productsItems, (item) => {
                return (_openBlock(), _createBlock(_component_slide, {
                  key: item.productId
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass(["card h-100 w-100", ['mx-' + _ctx.currentSettings.margin]])
                    }, [
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_Image, {
                          src: _ctx.getItemImage(item),
                          "max-size": 300,
                          role: "button",
                          "hide-frame": "",
                          class: "card-img-top",
                          style: {"max-width":"80% !important","margin":"auto"},
                          clickable: _ctx.componentOptions.navigateOnContentClick,
                          onClick: _withModifiers(($event: any) => (_ctx.componentOptions.navigateOnContentClick && _ctx.details(item)), ["prevent"])
                        }, null, 8, ["src", "clickable", "onClick"]),
                        (_ctx.componentOptions.imageOverlayTemplate)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                              _createVNode(_component_VRuntimeTemplate, {
                                template: _ctx.componentOptions.imageOverlayTemplate,
                                "template-props": { instance: _ctx.instance, item: item, emit: _ctx.emit, t: _ctx.t }
                              }, null, 8, ["template", "template-props"])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_4, [
                        (_ctx.componentOptions.detailsVisible)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              _createElementVNode("a", {
                                href: "",
                                onClick: _withModifiers(($event: any) => (_ctx.toggleItemDetails(item)), ["prevent"]),
                                class: "btn btn-link text-dark d-flex align-items-center"
                              }, [
                                _createVNode(_component_Icon, {
                                  glyph: "plus",
                                  class: "py-1",
                                  style: {"font-size":"1.1rem"}
                                })
                              ], 8, _hoisted_6)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_7, [
                          (_ctx.componentOptions.titleTemplate)
                            ? (_openBlock(), _createBlock(_component_VRuntimeTemplate, {
                                key: 0,
                                template: _ctx.componentOptions.titleTemplate,
                                "template-props": {
                      instance: _ctx.instance,
                      item,
                      emit: _ctx.emit,
                      details: _ctx.details,
                      baseProductDetails: _ctx.baseProductDetails,
                      attrValue: _ctx.attrValue,
                      t: _ctx.t,
                    }
                              }, null, 8, ["template", "template-props"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                (item.inactive)
                                  ? (_openBlock(), _createElementBlock("strong", _hoisted_9, _toDisplayString(_ctx.attrValue(item, '#DisplayName')), 1))
                                  : (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      href: "#",
                                      onClick: _withModifiers(($event: any) => (_ctx.details(item)), ["prevent"])
                                    }, [
                                      _createElementVNode("strong", null, _toDisplayString(_ctx.attrValue(item, '#DisplayName')), 1)
                                    ], 8, _hoisted_10)),
                                (item.productType === _ctx.catalogProductType.Configured)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                      _createElementVNode("em", null, _toDisplayString(_ctx.t('ConfiguredProducts')), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                        ]),
                        (_ctx.componentOptions.showAllIdentifiers)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.attrValues(item, '#AllIdentifiers'), (val, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "text-center small text-muted fw-bold my-2"
                              }, _toDisplayString(val), 1))
                            }), 128))
                          : _createCommentVNode("", true),
                        (_ctx.componentOptions.itemTemplate)
                          ? (_openBlock(), _createBlock(_component_VRuntimeTemplate, {
                              key: 2,
                              template: _ctx.componentOptions.itemTemplate,
                              "template-props": {
                    instance: _ctx.instance,
                    item,
                    emit: _ctx.emit,
                    details: _ctx.details,
                    baseProductDetails: _ctx.baseProductDetails,
                    attrValue: _ctx.attrValue,
                    attrValues: _ctx.attrValues,
                    t: _ctx.t,
                  }
                            }, null, 8, ["template", "template-props"]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              (item.customerClassification)
                                ? (_openBlock(), _createElementBlock("em", _hoisted_12, [
                                    _createTextVNode(_toDisplayString(_ctx.t('CustomerClassification')) + ":  " + _toDisplayString(item.customerClassification) + " ", 1),
                                    _hoisted_13
                                  ]))
                                : _createCommentVNode("", true),
                              (item.baseProduct)
                                ? (_openBlock(), _createElementBlock("em", _hoisted_14, [
                                    _createTextVNode(_toDisplayString(_ctx.t('BaseProductId')) + ":  ", 1),
                                    (!item.baseProduct.inactive)
                                      ? (_openBlock(), _createBlock(_component_Clickable, {
                                          key: 0,
                                          onClick: ($event: any) => (_ctx.baseProductDetails(item.baseProduct))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item.baseProduct.productId), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(item.baseProduct.productId), 1)),
                                    _hoisted_16
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                      ]),
                      (_ctx.componentOptions.actionTemplate)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              _createVNode(_component_VRuntimeTemplate, {
                                template: _ctx.componentOptions.actionTemplate,
                                "template-props": {
                    instance: _ctx.instance,
                    item,
                    emit: _ctx.emit,
                    details: _ctx.details,
                    baseProductDetails: _ctx.baseProductDetails,
                    attrValue: _ctx.attrValue,
                    attrValues: _ctx.attrValues,
                    t: _ctx.t,
                  }
                              }, null, 8, ["template", "template-props"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.componentOptions.selectable)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              class: "form-check-input",
                              checked: _ctx.instance?.selection.isSelected(item),
                              onClick: ($event: any) => (_ctx.instance?.selection.toggle(item))
                            }, null, 8, _hoisted_20)
                          ]))
                        : _createCommentVNode("", true)
                    ], 2)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 16, ["breakpoints", "i18n"])
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_ItemCatalogsDetailsModal, {
      "instance-id": _ctx.instanceId,
      item: _ctx.selectedItem,
      show: _ctx.catalogsModalVisible,
      t: _ctx.t,
      "all-catalogs": _ctx.showingAllCatalogs,
      onHidden: _cache[0] || (_cache[0] = ($event: any) => (_ctx.catalogsModalVisible = false))
    }, null, 8, ["instance-id", "item", "show", "t", "all-catalogs"])
  ], 10, _hoisted_1))
}